import { render, staticRenderFns } from "./proxy-detail.vue?vue&type=template&id=ba685de2&scoped=true&"
import script from "./proxy-detail.vue?vue&type=script&lang=js&"
export * from "./proxy-detail.vue?vue&type=script&lang=js&"
import style0 from "./proxy-detail.vue?vue&type=style&index=0&id=ba685de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba685de2",
  null
  
)

export default component.exports